import { DocumentoFiscalRecebidoDownloadStruct } from '../../structs/repo-dfe/documento-fiscal-recebido-download.struct';

export class DownloadDocumentosFiscaisRecebidosRequest {
    documentos: DocumentoFiscalRecebidoDownloadStruct[] = [];
}
